// SPDX-License-Identifier: GPL-3.0-only
// Copyright (C) 2026 Kyle Johnson
// This file is part of Hushold.
//
// Hushold is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as
// published by the Free Software Foundation, version 3.

// Language selector, Precision Dark styling. Works both pre-auth (login screen,
// worker=null → local only) and in-app (worker set → also syncs to the encrypted
// settings event). Options show each language's endonym.

import { useTranslation } from 'react-i18next';
import { useLanguage } from '../../hooks/useLanguage.js';

interface LanguageSwitcherProps {
  worker: Worker | null;
  /** Extra classes for the <select> (defaults to the standard settings field). */
  className?: string;
  id?: string;
}

const DEFAULT_SELECT_CLASS =
  'bg-bg-surface border border-border text-text text-sm px-3 py-2 focus:border-accent focus:outline-none';

export function LanguageSwitcher({ worker, className, id }: LanguageSwitcherProps) {
  const { t } = useTranslation('settings');
  const { current, change, locales } = useLanguage(worker);

  return (
    <select
      id={id}
      className={className ?? DEFAULT_SELECT_CLASS}
      value={current}
      aria-label={t('display.language')}
      onChange={(e) => void change(e.target.value)}
    >
      {locales.map((l) => (
        <option key={l.code} value={l.code}>
          {l.nativeName}
        </option>
      ))}
    </select>
  );
}
